import './Header.scss';

import { JSX } from 'react';

import LogoId from 'app/assets/logo-id.svg';
import LogoIdLight from 'app/assets/logo-id-light.svg';

import ThemeToggle from 'app/theme/ThemeToggle';

const Header = (): JSX.Element => {
  return (
    <header className="header">
      <div className="header-logo header__logo">
        <a className="header-logo__link" href="/login" aria-label="Unigine Developer Portal">
          <img
            src={LogoId}
            alt="Unigine Developer logo"
            className="header-logo__image header-logo__image--dark"
          />
          <img
            src={LogoIdLight}
            alt="Unigine Developer logo"
            className="header-logo__image header-logo__image--light"
          />
        </a>
      </div>

      <div className="header__main">
        <div className="header__controls">
          <ThemeToggle className="header__theme-toggle--desktop" />
        </div>
      </div>
    </header>
  );
};

export default Header;
